export const LOAD_DELIVERIES = 'trade-document-delivery/LOAD_DELIVERIES'

// Which packet a delivery record tracks (ADR_LOS-026). Open and Settled
// packets carry independent Prepared/Sent lifecycles per sub-trade.
export type PacketType = 'open' | 'settled'

export interface Delivery {
  subTradeId: string
  /**
   * Absent on records that predate the packetType field (pre-migration
   * ledger data, or a backend older than the frontend during a staggered
   * deploy) — consumers treat missing as the settled packet.
   */
  packetType?: PacketType
  documentName: string
  status: 'Prepared' | 'Sent' | 'PrepFailed' | 'SendFailed'
  preparedBy: string
  preparedAt: string
  sentBy: string | null
  sentAt: string | null
  /** When status is PrepFailed/SendFailed (LOS-6471). */
  failedAt?: string | null
  /**
   * Derived staleness (ADR_LOS-027): latest qualifying FacilityPaydown/PIK
   * processedTime when it is after sentAt. Only ever set on sent Open packets.
   */
  staleSince?: string | null
}

/**
 * When the record was last acted on: the latest of preparedAt / sentAt /
 * failedAt, ignoring absent or unparseable timestamps (0 when none parse).
 * Shared by the reducer's last-activity-wins merge and the Delivery cell's
 * most-current-packet pick so the two rankings cannot drift.
 */
export const activityAt = (d: Delivery): number => {
  const times = [d.preparedAt, d.sentAt, d.failedAt]
    .filter((t): t is string => !!t)
    .map(t => Date.parse(t))
    .filter(n => !isNaN(n))
  return times.length ? Math.max(...times) : 0
}
